import cookies from 'js-cookie';
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import {faHandsClapping, faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import FormLeadModule from 'modules/FormLeadModule';
import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import numeral from 'numeral';
import 'numeral/locales/es';
import {useActions} from 'contexts/ActionsMadeContext';

import eventsService from 'services/events';
import {IS_PRODUCTION} from 'environment';
import dayjs from 'dayjs';
import ImageCarousel from './ImageCarousel';

numeral.locale('es');
numeral.localeData().delimiters.thousands = ',';

const day = dayjs().format('YYYY-MM-DD');
const skickMonthlyPlanPrice: number = 149.9;
const skickBimonthlyPlanPrice: number = 239.9;
const skickTrimestralPlanPrice: number = 329.9;

const endDiscountDate = '2025-08-01';
const skickMonthlyPlanPriceDiscounted: number = 149.9;
const skickBimonthlyPlanPriceDiscounted: number =
  day < endDiscountDate ? 180 : 239.9;
const skickTrimestralPlanPriceDiscounted: number =
  day < endDiscountDate ? 247 : 329.9;

const smaxMonthlyPlanPrice: number = 219.9;
const smaxBimonthlyPlanPrice: number = 329.9;
const smaxTrimestralPlanPrice: number = 389.9;

const smaxBimonthlyPlanPriceDiscounted: number = 329.9;
const smaxTrimestralPlanPriceDiscounted: number = 389.9;

const landingDefinitions: Record<string, LandingDefinition> = {
  default: {
    headerImage: '/images/landing/header-scooters-3.jpeg',
    title: <h1>Alquila tu Grin por 1, 2 o 3 meses</h1>,
    benefits: [
      {
        title: 'Ahorra dinero',
        description:
          'Chau gasolina, pasajes, estacionamiento, taxis y más. ¡Te imaginas ahorrar 50 soles al mes o más! 🤯 ',
        icon: '/images/landing/money.png',
      },
      {
        title: 'Olvídate del tráfico',
        icon: '/images/landing/reloj.png',
        description:
          '¡Adiós estrés! Alquila tu patín y muévete rápido, seguro y divertido. Nunca más en el tráfico por 1 hora, llega a tu destino en 30 min o menos*',
      },
      {
        title: 'Mantenimientos ilimitados',
        icon: '/images/landing/mantenimiento.png',
        description: 'Si algo falla ¡Te lo cambiamos!',
      },
      {
        title: 'Cuida el planeta',
        icon: '/images/landing/ecology.png',
        description: 'Reduce tu huella de CO2',
      },
      {
        title: 'Atención personalizada',
        icon: '/images/landing/phone.png',
        description: 'Con solo un click ',
      },
      {
        title: 'Scooters resistentes',
        icon: '/images/landing/scooter-2.png',
        description:
          'Llantas sólidas y piso reforzado, ideales para las ciclovías limeñas ',
      },
    ],
    plans: [],
    plansSkick: [
      {
        id: 'skick_plan_1m',
        title: 'Mensual',
        whatsappMessage: {
          normal: `Hola Grin, quiero alquilar un scooter Skick en plan mensual de S/ ${numeral(
            skickMonthlyPlanPrice
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
          discounted: `Hola Grin, quiero alquilar un scooter Skick en plan mensual de S/ ${numeral(
            skickMonthlyPlanPriceDiscounted
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
        },
        description: {
          normal: (
            <div>
              <div>Ahórrate más de 50 soles al mes en transporte. **</div>
            </div>
          ),
          discounted: (
            <div>
              <div>Ahórrate más de 50 soles al mes en transporte. **</div>
            </div>
          ),
        },
        price: skickMonthlyPlanPrice,
        discountedPrice: skickMonthlyPlanPriceDiscounted,
        isDiscounted: skickMonthlyPlanPriceDiscounted !== skickMonthlyPlanPrice,
      },
      {
        id: 'skick_plan_2m',
        title: 'Bimestral',
        whatsappMessage: {
          normal: `Hola Grin, quiero alquilar un scooter Skick en plan bimestral de S/ ${numeral(
            skickBimonthlyPlanPrice
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
          discounted: `Hola Grin, quiero alquilar un scooter Skick en plan bimestral de S/ ${numeral(
            skickBimonthlyPlanPriceDiscounted
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
        },
        description: {
          normal: (
            <div>
              <div>
                Ahorras S/{' '}
                {numeral(
                  skickMonthlyPlanPrice * 2 - skickBimonthlyPlanPrice
                ).format('0,0.00')}{' '}
                en comparación al plan mensual
              </div>
            </div>
          ),
          discounted: (
            <div>
              <div>
                Ahorras S/{' '}
                {numeral(
                  skickMonthlyPlanPriceDiscounted * 2 -
                    skickBimonthlyPlanPriceDiscounted
                ).format('0,0')}{' '}
                en comparación al plan mensual
              </div>
            </div>
          ),
        },
        price: skickBimonthlyPlanPrice,
        discountedPrice: skickBimonthlyPlanPriceDiscounted,
        isDiscounted:
          skickBimonthlyPlanPriceDiscounted !== skickBimonthlyPlanPrice,
      },
      {
        id: 'skick_plan_3m',
        title: 'Trimestral',
        whatsappMessage: {
          normal: `Hola Grin, quiero alquilar un scooter Skick en plan trimestral de S/ ${numeral(
            skickTrimestralPlanPrice
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
          discounted: `Hola Grin, quiero alquilar un scooter Skick en plan trimestral de S/ ${numeral(
            skickTrimestralPlanPriceDiscounted
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
        },
        description: {
          normal: (
            <div>
              <div>
                Ahorras S/{' '}
                {numeral(
                  skickMonthlyPlanPrice * 3 - skickTrimestralPlanPrice
                ).format('0,0')}{' '}
                en comparación al plan mensual
              </div>
            </div>
          ),
          discounted: (
            <div>
              <div>
                Ahorras S/{' '}
                {numeral(
                  skickMonthlyPlanPriceDiscounted * 3 -
                    skickTrimestralPlanPriceDiscounted
                ).format('0,0')}{' '}
                en comparación al plan mensual
              </div>
            </div>
          ),
        },
        price: skickTrimestralPlanPrice,
        discountedPrice: skickTrimestralPlanPriceDiscounted,
        isDiscounted:
          skickTrimestralPlanPriceDiscounted !== skickTrimestralPlanPrice,
      },
    ],
    plansSmax: [
      {
        id: 'smax_plan_2m',
        title: 'Bimestral',
        whatsappMessage: {
          normal: `Hola Grin, quiero alquilar un scooter Smax en plan bimestral de S/ ${numeral(
            smaxBimonthlyPlanPrice
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
          discounted: `Hola Grin, quiero alquilar un scooter Smax en plan bimestral de S/ ${numeral(
            smaxBimonthlyPlanPriceDiscounted
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
        },
        description: {
          normal: <div />,
          discounted: <div />,
        },
        price: smaxBimonthlyPlanPrice,
        discountedPrice: smaxBimonthlyPlanPriceDiscounted,
        isDiscounted:
          smaxBimonthlyPlanPriceDiscounted !== smaxBimonthlyPlanPrice,
      },
      {
        id: 'smax_plan_3m',
        title: 'Trimestral',
        whatsappMessage: {
          normal: `Hola Grin, quiero alquilar un scooter Smax en plan trimestral de S/ ${numeral(
            smaxTrimestralPlanPrice
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
          discounted: `Hola Grin, quiero alquilar un scooter Smax en plan trimestral de S/ ${numeral(
            smaxTrimestralPlanPriceDiscounted
          ).format('0,0.00')}. ¿Me puedes dar más info?`,
        },
        description: {
          normal: (
            <div>
              <div>
                Ahorras S/{' '}
                {numeral(
                  smaxMonthlyPlanPrice * 1.5 - smaxTrimestralPlanPrice
                ).format('0,0')}{' '}
                en comparación al plan bimestral
              </div>
            </div>
          ),
          discounted: (
            <div>
              <div>
                Ahorras S/{' '}
                {numeral(
                  smaxBimonthlyPlanPriceDiscounted * 1.5 -
                    smaxTrimestralPlanPriceDiscounted
                ).format('0,0')}{' '}
                en comparación al plan bimestral
              </div>
            </div>
          ),
        },
        price: smaxTrimestralPlanPrice,
        discountedPrice: smaxTrimestralPlanPriceDiscounted,
        isDiscounted:
          smaxTrimestralPlanPriceDiscounted !== smaxTrimestralPlanPrice,
      },
    ],
    sales: [
      {
        id: 'smax_sale',
        title: 'Ninebot G30 Max',
        whatsappMessage: {
          normal: `¡Quiero comprar mi Ninebot G30 Max a un super precio por la oferta de verano!`,
          discounted: `¡Quiero comprar mi Ninebot G30 Max a un super precio por la oferta de verano!`,
        },
        image: '/images/smax-no-bg.png',
        images: [
          '/images/smax/smax-rojo.jpeg',
          '/images/smax/smax-amarillo.jpeg',
          '/images/smax/smax-azul.jpeg',
          '/images/smax/smax-verde.jpeg',
        ],
        extra: {
          colors: ['#CD282D', '#EEC02E', '#0E7CB8', '#52602D'],
        },
        description: {
          normal: (
            <div>
              Aquí puedes comprar tu Ninebot G30 Max a un precio increíble
            </div>
          ),
          discounted: (
            <div className='flex flex-col gap-8'>
              <div className='grid md:grid-cols-2 grid-cols-1 gap-y-4 gap-x-8 text-center'>
                <div>Autonomía de 35 km</div>
                <div>Velocidad máxima 30 km/h</div>
                <div>Llantas sólidas anti pinchazos</div>
                <div>Freno de tambor y eléctrico</div>
                <div className='md:col-span-2 col-span-1'>
                  Garantía de 6 meses*
                </div>
              </div>
              <div className='text-sm text-gray-700 font-sans'>
                *⁠ Aplican términos y condiciones
              </div>
            </div>
          ),
        },
        price: 2200,
        discountedPrice: 1500,
        isDiscounted: true,
      },
      {
        id: 'skick_sale',
        title: 'S-Kick',
        image: '/images/skick-no-bg.png',
        images: [
          '/images/skick/skick-rojo.jpeg',
          '/images/skick/skick-amarillo.jpeg',
          '/images/skick/skick-azul.jpeg',
          '/images/skick/skick-verde.jpeg',
        ],
        whatsappMessage: {
          normal: `¡Quiero comprar mi S-Kick a un super precio por la oferta de verano!`,
          discounted: `¡Quiero comprar mi S-Kick a un super precio por la oferta de verano!`,
        },
        extra: {
          colors: ['#CD282D', '#EEC02E', '#0E7CB8', '#52602D'],
        },
        description: {
          normal: (
            <div>Aquí puedes comprar tu S-Kick a un precio increíble</div>
          ),
          discounted: (
            <div className='flex flex-col gap-8'>
              <div className='grid md:grid-cols-2 grid-cols-1 gap-y-4 gap-x-8 text-center'>
                <div>Autonomía de 15 km</div>
                <div>Velocidad Máxima 30 km/h</div>
                <div>Llantas Sólidas anti pinchazos</div>
                <div>Amortiguación Delantera</div>
                <div>Freno Eléctrico y Mecánico</div>
                <div>Garantía de 6 meses*</div>
              </div>
              <div className='text-sm text-gray-700 font-sans'>
                *⁠ Aplican términos y condiciones
              </div>
            </div>
          ),
        },
        price: 1200,
        discountedPrice: 800,
        isDiscounted: true,
      },
    ],
  },
};
landingDefinitions.default.plans = [
  ...landingDefinitions.default.plansSkick,
  ...landingDefinitions.default.plansSmax,
  ...(landingDefinitions.default.sales ?? []),
];
function LandingModule() {
  const {actions, addAction} = useActions();
  const [startTime] = useState(new Date().getTime());
  const [showForm, setShowForm] = useState(false);
  const [stage, setStage] = useState<string>('init');
  const [selectedPlan, setSelectedPlan] = useState<string>('');
  const [createdLead, setCreatedLead] = useState<Lead>();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsQuery = Object.fromEntries(searchParams);
  const utmSource = (searchParamsQuery.utm_source ?? '').toLowerCase();
  const utmCampaign = (searchParamsQuery.utm_source ?? '').toLowerCase();
  const emojis: Record<string, string> = {
    meta: '💚',
    google: utmCampaign === 'xxx' ? '??' : '🛴 🚀',
  };

  const useEmojiForWhatsApp = emojis[utmSource] ?? '';

  const source =
    searchParams && typeof searchParams.get('source') === 'string'
      ? (searchParams.get('source') as string)
      : 'direct';

  const {referrer} = document;

  const landingId =
    searchParams &&
    typeof searchParams.get('lid') === 'string' &&
    (searchParams.get('lid') as string) in landingDefinitions
      ? (searchParams.get('lid') as string)
      : 'default';

  if (landingId === null) {
    return null;
  }

  const landing: LandingDefinition = landingDefinitions[landingId];

  useEffect(() => {
    if (!selectedPlan) {
      return;
    }
    setSearchParams((prev) => {
      prev.set('plan', selectedPlan);
      return prev;
    });
  }, [selectedPlan]);

  useEffect(() => {
    setSearchParams((prev) => {
      if (stage !== 'init' && prev.get('status') !== stage) {
        addAction({
          action: 'changeToStage',
          stage,
        });
      }
      prev.set('status', stage ?? '');
      return prev;
    });
  }, [stage]);

  const getVisitorId = () => {
    const cVisitorId = cookies.get('__vid');
    let visitorId: number;
    if (cVisitorId) {
      visitorId = parseInt(cVisitorId, 10);
    } else {
      visitorId = Math.floor(Math.random() * 2147483647);
      cookies.set('__vid', String(visitorId), {expires: 28, path: ''});
    }
    return visitorId;
  };

  const sendGoogleEvent = (event: string, sendTo: string) => {
    if (typeof window !== 'undefined') {
      window.gtag('event', event, {
        send_to: sendTo,
      });
    }
  };

  const storeVisitorEvent = async (
    event: string,
    data: Record<string, any>
  ) => {
    if (!IS_PRODUCTION) {
      return;
    }
    const payload = {
      event,
      item_type: 'visitor',
      user_id: 0,
      item_id: getVisitorId(),
      lat: 0,
      lng: 0,
      data,
    };
    await eventsService.create(payload);
  };
  useEffect(() => {
    addAction({
      action: 'init',
    });
    storeVisitorEvent('landing:init', {
      source,
      landingId,
      referrer,
      queryParams: Object.fromEntries(searchParams),
    });
  }, []);

  const onCreateLead = (lead: Lead) => {
    setCreatedLead(lead);
    setStage('complete');
    storeVisitorEvent('landing:complete', {
      source,
      landingId,
      leadId: lead.id,
      referrer,
      queryParams: Object.fromEntries(searchParams),
    });
  };

  const selectPlan = async (plan: string) => {
    setSelectedPlan(plan);
    // @ts-expect-error
    window.dataLayer.push({event: `test_${plan}`});
    addAction({
      action: 'selectPlan',
      plan,
    });

    const action = 'whatsapp';
    if (action === 'whatsapp') {
      const sendToMap = {
        plan_1m: 'AW-16533372114/Ny8KCKeO5-AZENL53Ms9',
        plan_2m: 'AW-16533372114/DwM4CKqO5-AZENL53Ms9',
        plan_3m: 'AW-16533372114/BLfFCK2O5-AZENL53Ms9',
      };
      if (plan in sendToMap) {
        sendGoogleEvent(
          'conversion',
          sendToMap[plan as keyof typeof sendToMap]
        );
      }
      await storeVisitorEvent('landing:interested', {
        source,
        landingId,
        nextAction: 'WhatsApp',
        referrer,
        plan,
        queryParams: Object.fromEntries(searchParams),
      });

      const splan = landing.plans.find((p) => p.id === plan);
      if (!splan) {
        return;
      }

      const whatsappMessage =
        splan.whatsappMessage &&
        typeof splan.whatsappMessage === 'object' &&
        'discounted' in splan.whatsappMessage
          ? splan.whatsappMessage.discounted
          : splan.whatsappMessage;

      document.location = `https://api.whatsapp.com/send/?phone=51964116143&text=${encodeURIComponent(
        `${whatsappMessage} ${useEmojiForWhatsApp}`
      )}`;
    } else {
      storeVisitorEvent('landing:interested', {
        source,
        landingId,
        referrer,
        nextAction: 'showLeadForm',
        plan,
        queryParams: Object.fromEntries(searchParams),
      });

      setCreatedLead(undefined);
      setShowForm(true);
      addAction({
        action: 'showForm',
      });
      setStage('interested');
    }
  };

  const closeForm = () => {
    setSelectedPlan('');
    setShowForm(false);
    setStage('');
    addAction({
      action: 'closeForm',
    });
    storeVisitorEvent('landing:closeForm', {
      source,
      landingId,
      referrer,
      queryParams: Object.fromEntries(searchParams),
    });
  };

  if (!landing) {
    return null;
  }
  return (
    <div className='relative font-sec'>
      <div className='fixed bottom-4 right-4 z-[100] '>
        <a
          onClick={() => {
            sendGoogleEvent(
              'conversion',
              'AW-16533372114/SeJ9CKSO5-AZENL53Ms9'
            );
            return false;
          }}
          href={`https://api.whatsapp.com/send/?phone=51964116143&text=${encodeURI(
            `Hola revisé su web, ¿me pueden dar más información? ${useEmojiForWhatsApp}`
          )}`}
          target='_blank'
          rel='noreferrer'
          className='block bg-main-500 p-4 rounded-full shadow-lg border-2 border-white'
        >
          <FontAwesomeIcon icon={faWhatsapp} className='text-white text-4xl' />
        </a>
      </div>
      <div className='section'>
        <div className=''>
          <div>
            <div
              className='relative w-full sm:h-[70dvh] h-[50dvh] bg-cover bg-center '
              style={{
                backgroundImage: `url(${landing.headerImage})`,
              }}
            >
              <div className='bg-black p-2 absolute top-2 left-2 sm:p-4 sm:top-8 sm:left-8 rounded-full'>
                <img
                  src='/images/grin-logo.svg'
                  alt='Grin'
                  className='size-8 sm:size-16'
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='section bg-bottom pb-[100px] bg-repeat-y bg-contain  md:border-t-[20px] border-t-[40px] border-yellow-500'
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form-2.jpg)',
        }}
      >
        <div className='inner md:-mt-[120px] -mt-[105px]'>
          <div className='text-center'>
            <div
              className='title-2 text-center mb-12 bg-yellow-500 text-white inline-block p-4 px-10 mx-auto'
              style={{
                transform: 'skew(-10deg)',
              }}
            >
              <h2
                style={{
                  transform: 'skew(10deg)',
                }}
              >
                ¡Gran venta de verano!
              </h2>
            </div>
            <div className='text-center mb-16 md:text-4xl text-2xl'>
              Compra tu Scooter a Precio de Verano y deja de gastar en taxis,
              micros o gasolina
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-12 gap-y-16 justify-center mb-16'>
              {landing.sales?.map((sale) => (
                <div className='rounded-lg bg-white shadow-xl pb-10 relative'>
                  <div className='font-normal font-main bg-yellow-500 p-2 py-4  text-white mt-8 text-center text-6xl relative border-y-10 z-10'>
                    <span> {sale.title}</span>
                  </div>
                  <div className='grid grid-cols-1 items-center mt-16 mb-0 sm:mt-4 z-10 relative'>
                    <div className='grid grid-cols-1 md:grid-cols-[1fr] gap-2 items-start justify-start'>
                      <div className='text-center relative'>
                        {sale.images && sale.images.length > 0 ? (
                          <ImageCarousel
                            images={sale.images}
                            title={sale.title}
                          />
                        ) : (
                          <img
                            src={sale.image}
                            alt={sale.title}
                            className=' w-[80%] mx-auto md:w-[70%]'
                          />
                        )}
                        {sale.extra?.colors && (
                          <div className='flex items-start flex-col gap-2 pl-6 mt-2'>
                            <div className='text-sm'>Disponible en:</div>
                            <div className='flex justify-center items-center gap-2'>
                              {sale.extra.colors.map((color) => (
                                <div
                                  key={color}
                                  className='size-6 md:size-8 rounded-lg'
                                  style={{
                                    backgroundColor: color,
                                  }}
                                />
                              ))}
                            </div>
                          </div>
                        )}
                        <div className='absolute bottom-[-25px] left-0 right-0 z-[100]'>
                          <div className='ribbon bg-gray-600'>
                            <span className='md:text-2xl text-md p-2 inline-block font-normal'>
                              Elige tu color preferido
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className=''>
                        {sale.isDiscounted &&
                          sale.discountedPrice !== sale.price && (
                            <div className='line-through text-3xl mt-4 -mb-4 text-gray-400'>
                              S./ {numeral(sale.price).format('0,0')}
                            </div>
                          )}
                        <div className='text-center pt-8 pb-8 sm:py-8  font-normal  flex justify-center items-start gap-2 font-main text-yellow-600'>
                          <span className='text-4xl mt-2 '>S./</span>
                          <div className='flex items-end '>
                            <span className='text-[6rem] sm:text-[7rem] leading-[6rem] font-normal'>
                              {numeral(
                                Math.floor(sale.discountedPrice ?? sale.price)
                              ).format('0,0')}
                            </span>
                            {`${sale.discountedPrice ?? sale.price}`.split(
                              '.'
                            )[1] && (
                              <span className='text-4xl ml-[2px] mb-[5px]'>
                                .
                                {parseInt(
                                  `${sale.discountedPrice ?? sale.price}`.split(
                                    '.'
                                  )[1],
                                  10
                                ) * 10}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className='text-xl sm:text-2xl text-black px-8 leading-[125%] text-left sm:text-center font-sec font-light mt-8 mb-8'>
                          {sale.description &&
                          typeof sale.description === 'object' &&
                          'discounted' in sale.description
                            ? sale.description.discounted
                            : sale.description}
                        </div>
                        <div className='text-center z-10 '>
                          <button
                            type='button'
                            className={`button button-inverse hover:!bg-yellow-600 hover:!text-white big mx-auto bg-yellow-500 !inline-block plan_button_${sale.id}`}
                            onClick={() => selectPlan(sale.id)}
                          >
                            <div className='flex gap-4 items-center'>
                              <FontAwesomeIcon
                                icon={faWhatsapp}
                                className='text-white text-4xl'
                              />
                              <span>Quiero comprar</span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className='text-center mb-0 mt-24 text-4xl text-yellow-600'>
              * Solo 50 unidades en stock, ¡compra el tuyo ahora!
            </div>
          </div>
        </div>
      </div>

      <div
        className='
                text-4xl font-main sm:text-8xl p-2
                bottom-0 left-0 right-0
                leading-[125%]
                bg-black text-white  text-center sm:p-4 mx-auto
              '
      >
        <div className='max-w-[60%] sm:max-w-[80%] mx-auto'>
          {landing.title}
        </div>
      </div>

      {landing.plansSkick && landing.plansSkick.length > 0 && (
        <div
          className='section bg-main-500 bg-cover bg-bottom pb-[100px]'
          style={{
            backgroundImage: 'url(/images/bg-plans.jpg)',
          }}
        >
          <div className='inner'>
            <div className='text-center'>
              <div
                className='title-2 text-center mb-12 bg-white text-black inline-block p-4 mx-auto'
                style={{
                  transform: 'skew(-10deg)',
                }}
              >
                <h2
                  style={{
                    transform: 'skew(10deg)',
                  }}
                >
                  Alquila tu Scooter Skick
                </h2>
              </div>
              <div
                className='grid grid-cols-1 md:grid-cols-4 items-stretch  gap-4 text-black text-lg md:text-2xl mb-8 bg-white/100 p-4 md:divide-x md:divide-black rounded-lg'
                style={{
                  transform: 'skew(0deg)',
                }}
              >
                <div
                  className='px-4'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  Ligero
                </div>
                <div
                  className='px-4'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  12 km de autonomía
                </div>
                <div
                  className='px-4'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  Ideal para distancias cortas y medias
                </div>
                <div
                  className='px-4'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  Carga rápida de 20% a 80% en 1.5 horas
                </div>
              </div>
              <div className='grid grid-cols-1 md:grid-cols-3 gap-12 gap-y-16 justify-center  mb-16'>
                {landing.plansSkick.map((plan) => (
                  <div className='rounded-lg bg-white shadow-xl relative pb-10 '>
                    <div className='font-normal font-main bg-black p-2 py-4  text-white mt-8 text-center text-6xl'>
                      {plan.title}
                    </div>
                    <div className='grid grid-cols-1 items-center my-16 sm:mt-4'>
                      {plan.isDiscounted &&
                        plan.discountedPrice !== plan.price && (
                          <div className='line-through text-3xl mt-4 -mb-4 text-gray-400'>
                            S./ {numeral(plan.price).format('0.00')}
                          </div>
                        )}
                      <div className='text-center pb-8 sm:py-8  font-normal  flex justify-center items-start gap-2 font-main text-black'>
                        <span className='text-4xl mt-2 '>S./</span>
                        <div className='flex items-end '>
                          <span className='text-[6rem] sm:text-[7rem] leading-[6rem] font-normal'>
                            {numeral(
                              Math.floor(plan.discountedPrice ?? plan.price)
                            ).format('0')}
                          </span>
                          {`${plan.discountedPrice ?? plan.price}`.split(
                            '.'
                          )[1] && (
                            <span className='text-4xl ml-[2px] mb-[5px]'>
                              .
                              {parseInt(
                                `${plan.discountedPrice ?? plan.price}`.split(
                                  '.'
                                )[1],
                                10
                              ) * 10}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className='text-xl sm:text-2xl text-black px-8 leading-[125%] text-left sm:text-center font-sec font-light'>
                        {plan.description &&
                        typeof plan.description === 'object' &&
                        'discounted' in plan.description
                          ? plan.description.discounted
                          : plan.description}
                      </div>
                    </div>
                    <div className='text-center absolute bottom-[-20px] left-0 right-0'>
                      <button
                        type='button'
                        className={`button button-inverse big mx-auto mt-10 bg-black !inline-block plan_button_${plan.id}`}
                        onClick={() => selectPlan(plan.id)}
                      >
                        <div className='flex gap-4 items-center'>
                          <FontAwesomeIcon
                            icon={faWhatsapp}
                            className='text-white text-4xl'
                          />
                          <span>Quiero alquilar</span>
                        </div>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {landing.plansSmax && landing.plansSmax.length > 0 && (
        <div
          className='section bg-main-500 bg-cover bg-bottom pb-[100px]'
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form.jpg)',
          }}
        >
          <div className='inner'>
            <div className='text-center'>
              <div
                className='title-2 text-center mb-12 bg-main-500 text-black inline-block p-4 mx-auto'
                style={{
                  transform: 'skew(-10deg)',
                }}
              >
                <h2
                  style={{
                    transform: 'skew(10deg)',
                  }}
                >
                  Alquila tu Scooter Smax
                </h2>
              </div>
              <div
                className='grid grid-cols-1 md:grid-cols-4 items-stretch  gap-4 text-black text-lg md:text-2xl mb-8 bg-white/100 p-4 md:divide-x md:divide-black rounded-lg'
                style={{
                  transform: 'skew(0deg)',
                }}
              >
                <div
                  style={{
                    transform: 'skew(0deg)',
                  }}
                  className='px-4'
                >
                  Ideal para distancias largas
                </div>
                <div
                  className='px-'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  Autonomía de 25 a 30 km
                </div>
                <div
                  className='px-4'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  Carga de 20% a 80% en 2.5 horas
                </div>
                <div
                  className='px-4'
                  style={{
                    transform: 'skew(0deg)',
                  }}
                >
                  Freno de tambor delantero y eléctrico trasero
                </div>
              </div>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-12 gap-y-16 justify-center  mb-16'>
                {landing.plansSmax.map((plan) => (
                  <div className='rounded-lg bg-white shadow-xl relative pb-10 '>
                    <div className='font-normal font-main bg-black p-2 py-4  text-white mt-8 text-center text-6xl'>
                      {plan.title}
                    </div>
                    <div className='grid grid-cols-1 items-center my-16 sm:mt-4'>
                      {plan.isDiscounted &&
                        plan.discountedPrice !== plan.price && (
                          <div className='line-through text-3xl mt-4 -mb-4 text-gray-400'>
                            S./ {numeral(plan.price).format('0.00')}
                          </div>
                        )}
                      <div className='text-center pb-8 sm:py-8  font-normal  flex justify-center items-start gap-2 font-main text-black'>
                        <span className='text-4xl mt-2 '>S./</span>
                        <div className='flex items-end '>
                          <span className='text-[6rem] sm:text-[7rem] leading-[6rem] font-normal'>
                            {numeral(
                              Math.floor(plan.discountedPrice ?? plan.price)
                            ).format('0')}
                          </span>
                          {`${plan.discountedPrice ?? plan.price}`.split(
                            '.'
                          )[1] && (
                            <span className='text-4xl ml-[2px] mb-[5px]'>
                              .
                              {parseInt(
                                `${plan.discountedPrice ?? plan.price}`.split(
                                  '.'
                                )[1],
                                10
                              ) * 10}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className='text-xl sm:text-2xl text-black px-8 leading-[125%] text-left sm:text-center font-sec font-light'>
                        {plan.description &&
                        typeof plan.description === 'object' &&
                        'discounted' in plan.description
                          ? plan.description.discounted
                          : plan.description}
                      </div>
                    </div>
                    <div className='text-center absolute bottom-[-20px] left-0 right-0'>
                      <button
                        type='button'
                        className={`button button-inverse big mx-auto mt-10 bg-black !inline-block plan_button_${plan.id}`}
                        onClick={() => selectPlan(plan.id)}
                      >
                        <div className='flex gap-4 items-center'>
                          <FontAwesomeIcon
                            icon={faWhatsapp}
                            className='text-white text-4xl'
                          />
                          <span>Quiero alquilar</span>
                        </div>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {landing.benefits && landing.benefits.length > 0 && (
        <div
          className='section bg-auto bg-top'
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form.jpg)',
          }}
        >
          <div className='inner py-24'>
            <div className='text-center'>
              <div
                className='title-2 text-center mb-16 bg-main-500 text-black inline-block p-4 mx-auto'
                style={{
                  transform: 'skew(-10deg)',
                }}
              >
                <h2
                  style={{
                    transform: 'skew(10deg)',
                  }}
                >
                  Beneficios
                </h2>
              </div>
              <div className='grid grid-cols-2 sm:grid-cols-3 gap-8 gap-y-16'>
                {landing.benefits.map((benefit) => (
                  <div
                    key={benefit.title}
                    className='flex  flex-col text-center gap-4 sm:p-8 justify-center'
                  >
                    <div className='text-center'>
                      <img
                        src={benefit.icon}
                        className='bg-main-500 bg-opacity-20 p-4 rounded-2xl size-24 sm:size-24 inline-block mx-auto'
                        alt=''
                      />
                    </div>
                    <div className='flex-grow text-center'>
                      <div className='font-semibold font-sec text-black text-2xl'>
                        {benefit.title}
                      </div>
                      <div className='text-black mt-2 text-md font-sec'>
                        {benefit.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className='section bg-auto bg-top'
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form.jpg)',
        }}
      >
        <div className='inner'>
          <div className='text-center'>
            <div
              className='title-2 text-center mb-12 bg-main-500 text-black inline-block p-4 mx-auto'
              style={{
                transform: 'skew(-10deg)',
              }}
            >
              <h2
                style={{
                  transform: 'skew(10deg)',
                }}
              >
                ¡Sabías que!
              </h2>
            </div>
            <div className='grid grid-cols-1 sm:grid-cols-3 gap-16 text-2xl mt-16'>
              <div>
                Con cualquiera de nuestros planes Grin4u vas a tener un scooter
                en tu casa como si fuera tuyo. 24/7
              </div>
              <div>Te enviamos tu scooter en menos de 48 horas.</div>
              <div>Te cambiamos el scooter ante cualquier falla.</div>
            </div>
          </div>
        </div>
      </div>

      {showForm && (
        <div className=' fixed inset-0 bg-black bg-opacity-85 grid justify-center items-center'>
          <div
            className='bg-bottom w-[90vw] sm:w-auto bg-cover p-4 sm:p-8 rounded sm:rounded-lg relative z-200 h-[95dvh] sm:h-auto overflow-y-auto'
            style={{
              backgroundImage:
                'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form.jpg)',
            }}
          >
            <div className='absolute right-4 top-4'>
              <button type='button' onClick={closeForm}>
                <FontAwesomeIcon icon={faTimes} className='text-2xl' />
              </button>
            </div>
            <div className='inner sm:p-6 '>
              {createdLead ? (
                <div className='text-center py-20'>
                  <div className='flex gap-8 justify-center items-center mt-8'>
                    <FontAwesomeIcon
                      icon={faHandsClapping}
                      className='text-main-500  text-6xl'
                    />
                    <span className='text-6xl font-main font-normal'>
                      Gracias!
                    </span>
                  </div>
                  <div className='mt-12 text-xl'>
                    Te contactaremos en breve via WhatsApp
                  </div>
                </div>
              ) : (
                <>
                  <div className='mb-10'>
                    <div className='title-2 mt-8 text-center text-main-600'>
                      ¿Estás interesado?
                    </div>
                    <div className='subtitle-2 text-lg sm:text-xl -mt-4 mb-4 text-center'>
                      Déjanos tus datos y te contactaremos a la brevedad
                    </div>
                  </div>
                  <FormLeadModule
                    extraParams={{
                      referrer,
                      queryParams: Object.fromEntries(searchParams),
                      actions,
                    }}
                    startTime={startTime}
                    selectedPlan={selectedPlan ?? 'noplan'}
                    landingId={landingId}
                    onCreateLead={onCreateLead}
                    source={source}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <div
        className='section bg-white text-black p-8 pt-16'
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form.jpg)',
        }}
      >
        <div className='flex flex-col gap-4 font-light'>
          <div>
            * Calculado en base a una ruta de diaria ida y vuelta de transporte
            metropolitano y un bus alimentador en hora punta.
          </div>
          <div>
            ** Calculado en base a una ruta de Miraflores a San Miguel entre las
            6 y 7 pm.
          </div>
        </div>
      </div>
      <div
        className='section bg-white text-black p-8 pt-16'
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0), rgba(255, 255, 255, .15)), url(/images/bg-form.jpg)',
        }}
      >
        <div className='flex gap-4 items-center justify-between'>
          <div className='flex gap-4 flex-col'>
            <div>
              <a
                href='https://reclamovirtual.pe/reclamar/Libro-de-Reclamaciones-Grin-Peru/barranco'
                target='_blank'
                rel='noreferrer'
              >
                <img
                  src='/images/libro-reclamaciones.jpeg'
                  alt='Libro de reclamaciones'
                  className='w-36 md:w-40 rounded shadow-lg'
                />
              </a>
            </div>
            <div className='flex gap-4 items-center'>
              <a
                href='https://www.facebook.com/grinpe'
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon
                  icon={faFacebook}
                  fixedWidth
                  className='text-4xl text-black hover:text-main-500'
                />
              </a>
              <a
                href='https://www.instagram.com/grin_peru'
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  fixedWidth
                  className='text-4xl text-black hover:text-main-500'
                />
              </a>
            </div>
          </div>
          <div className='text-center text-md'>
            © Grin Perú 2024 Todos los derechos reservados
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingModule;
